// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: "Poppins" !important;
}
.dashboard-layout {
  display: flex;
  height: 100vh;
}
.sidebar {
  width: 350px;
  background-color: #ffffff;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);
  position: relative;
}
.main-content {
  width: 100%;
  background-color: #f0f0f0;
  margin-top: 0.6rem;
}
.accordion-button:focus {
  box-shadow: none !important;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 4px;
  height: 4px;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  visibility: hidden;
  -webkit-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}

.custom-scrollbar:hover::-webkit-scrollbar-thumb,
.custom-scrollbar:active::-webkit-scrollbar-thumb {
  visibility: visible;
  background: rgba(0, 0, 0, 0.6);
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,iCAAiC;AACnC;AACA;EACE,aAAa;EACb,aAAa;AACf;AACA;EACE,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,wCAAwC;EACxC,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,wCAAgC;EAAhC,gCAAgC;AAClC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,wCAAgC;EAAhC,gCAAgC;AAClC;;AAEA;;EAEE,mBAAmB;EACnB,8BAA8B;AAChC","sourcesContent":["body {\n  font-family: \"Poppins\" !important;\n}\n.dashboard-layout {\n  display: flex;\n  height: 100vh;\n}\n.sidebar {\n  width: 350px;\n  background-color: #ffffff;\n  padding-top: 20px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  box-shadow: 2px 0 5px rgba(0, 0, 0, 0.1);\n  position: relative;\n}\n.main-content {\n  width: 100%;\n  background-color: #f0f0f0;\n  margin-top: 0.6rem;\n}\n.accordion-button:focus {\n  box-shadow: none !important;\n}\n\n.custom-scrollbar::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n  transition: all 0.3s ease-in-out;\n}\n\n.custom-scrollbar::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.custom-scrollbar::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.3);\n  border-radius: 10px;\n  visibility: hidden;\n  transition: all 0.3s ease-in-out;\n}\n\n.custom-scrollbar:hover::-webkit-scrollbar-thumb,\n.custom-scrollbar:active::-webkit-scrollbar-thumb {\n  visibility: visible;\n  background: rgba(0, 0, 0, 0.6);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
